import React, { useEffect } from 'react';

import { Button, Dialog, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles({
  modalContainer: {
    border: 'solid 1px rgba(0, 0, 0, 0.12)',
    borderRadius: '4px',
    boxShadow: 'none',
    backgroundColor: '#fff',
  },
  contentContainer: {
    padding: '70px 102px',
    textAlign: 'center',
  },
  backdrop: {
    backgroundColor: 'rgba(255,255,255,0)',
  },
  button: {
    height: '60px',
  },
  title: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: 1.3,
    letterSpacing: '0.26px',
    marginBottom: '16px',
  },
  subTitle: {
    color: '#a4a8ac',
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: 1.36,
    marginBottom: '24px',
  },
});

export const CodeExpiredModal = ({ isOpen, resetPage }) => {
  const classes = useStyles();

  useEffect(() => {
    const root = document.getElementById('root');

    if (isOpen) {
      root.style.filter = 'blur(17.3px)';
    } else {
      root.style.filter = 'none';
    }

    return () => {
      root.style.filter = 'none';
    };
  }, [isOpen]);

  return (
    <Dialog
      disableBackdropClick
      onClose={() => {}}
      aria-labelledby="password-reset-success-modal"
      open={isOpen}
      classes={{ paper: classes.modalContainer }}
      BackdropProps={{ classes: { root: classes.backdrop } }}
    >
      <div className={classes.contentContainer}>
        <Typography classes={{ root: classes.title }}>Code Expired</Typography>
        <Typography classes={{ root: classes.subTitle }}>
          Looks like you're a bit late and the code has expired, Try resetting
          your password again for new code.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          classes={{ root: classes.button }}
          onClick={resetPage}
          fullWidth
        >
          Reset Password
        </Button>
      </div>
    </Dialog>
  );
};
